import { FC, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { usePermission, useTranslation } from 'hooks';
import Tooltip from 'react-tooltip';
import Animation from 'components/ui/animation';
import Link from 'components/ui/link';
import I18nHelpers from 'i18n/I18nHelpers';
import { MainMenuItem } from './components/MainMenuItem';
import { RootState } from 'store';
import { legacyMenuConfiguration } from 'constants/menuConfiguration';
import './mainMenu.scss';

export const MainMenu: FC = () => {
  const location = useLocation();
  const getTranslate = useTranslation();
  const { isEnabled } = usePermission();
  const isMenuExpanded = useSelector(
    (state: RootState) => state.layoutConfiguration.isMenuExpanded
  );

  useEffect(() => {
    Tooltip.rebuild();
  }, [isMenuExpanded]);

  const menuItems = useMemo(() => {
    return legacyMenuConfiguration.filter(({ permissions }) => {
      if (!permissions) {
        return true;
      }

      return permissions.some((permission) => isEnabled(permission));
    });
  }, []);

  return (
    <div
      className={classNames('main-menu', {
        'main-menu_closed': !isMenuExpanded,
      })}>
      <Animation>
        <div className='main-menu__items'>
          {menuItems.map((item, index) => {
            const { path, title, icon } = item;
            return (
              <div
                key={`${path}${index}`}
                data-html={true}
                data-for='html'
                data-tip={
                  !isMenuExpanded
                    ? I18nHelpers.getHtmlString(getTranslate(title))
                    : undefined
                }
                data-class='tooltip-info_brand tooltip-info_main-menu'
                className={classNames('main-menu__item', {
                  'main-menu__item_current': location.pathname.includes(path),
                })}>
                <Link
                  className={classNames('main-menu__item-inner')}
                  url={path}>
                  {item.customComponent ? (
                    <item.customComponent
                      icon={icon}
                      title={getTranslate(title)}
                    />
                  ) : (
                    <MainMenuItem icon={icon} title={getTranslate(title)} />
                  )}
                </Link>
              </div>
            );
          })}
        </div>
      </Animation>
    </div>
  );
};
